var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#007AFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0516 6.5H7.94768C6.45766 6.5 5.51325 8.10728 6.26288 9.40663L11.2643 18.0755C11.5907 18.6415 12.4086 18.6415 12.7349 18.0755L17.7374 9.40663C18.486 8.10936 17.5416 6.5 16.0526 6.5H16.0516ZM11.2602 15.4758L10.171 13.3678L7.54282 8.66721C7.36944 8.36635 7.58359 7.98082 7.94666 7.98082H11.2592V15.4768L11.2602 15.4758ZM16.4544 8.6662L13.8272 13.3688L12.738 15.4758V7.9798H16.0505C16.4136 7.9798 16.6278 8.36534 16.4544 8.6662Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTonIcon);
export default __webpack_public_path__ + "static/media/ton_icon.d7bc93b1b5b63ee88e01a43701916795.svg";
export { ForwardRef as ReactComponent };